import React, { useEffect, useState } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import { getMenuMailRuAction } from 'actions/menuMailruAction'
import { Colors } from 'common-constants/colors'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { indexPath } from 'components/paths'
import { SideBarButtonSvg } from 'components/presentational/svg/SideBarButtonSvg'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { createLoveMailRuSidebarMenu } from './function/loveMailru'

export const LoveMailru = () => {
  const dispatch = useDispatch()
  const [show, setShow] = useState<boolean>(false)

  const handleShowMenu = () => {
    setShow(!show)
  }

  const { menu } = useShallowEqualSelector(
    ({ menuSideBarMailruReducer: { menu } }) => ({
      menu,
    })
  )

  useEffect(() => {
    if (menu.length === 0) {
      Promise.all([
        createLoveMailRuSidebarMenu(
          'https://ad.mail.ru/adq/?&q%5B%5D=1314&sz=5'
        ),
        createLoveMailRuSidebarMenu(
          'https://ad.mail.ru/adq/?q%5B%5D=6640&sz=5'
        ),
      ]).then((data: unknown) => {
        const sideBarMailruMenu = (data as string[]).reduce(
          (acc, link) => [...acc, ...JSON.parse(link)],
          []
        )
        dispatch(getMenuMailRuAction(sideBarMailruMenu))
      })
    }
  }, [dispatch, menu])

  return (
    <MenuBurger>
      <Burger onClick={handleShowMenu}>
        <SideBarButtonSvg color="currentColor" />
      </Burger>
      <Logo>
        <a
          href="https://mail.ru/?utm_source=portal&amp;utm_medium=logo_portal_navigation&amp;utm_campaign=mail.ru&amp;mt_link_id=o4lsx4&amp;mt_sub1=love.mail.ru"
          className={cx(linkCss)}
        >
          <img
            src="https://home.imgsmail.ru/whiteline/assets/logo/light/at.svg"
            alt="Mail.ru"
            height="30"
            style={{
              verticalAlign: 'top',
            }}
          />
        </a>
        <Link
          to={indexPath}
          className={cx(linkCss)}
          style={{
            flexGrow: '1',
          }}
        >
          <img
            src="https://r.mradx.net/img/63/09BC2C.svg"
            alt="logo-project-name"
            data-logo-img=""
            height="30"
            style={{
              verticalAlign: 'top',
            }}
          />
        </Link>
      </Logo>
      <SlideMenu className={cx(show && showMenuCss)}>
        {menu.map(({ name, url }) => (
          <ExternalLink href={url} target="_blank" key={url}>
            {name}
          </ExternalLink>
        ))}
      </SlideMenu>
    </MenuBurger>
  )
}

const MenuBurger = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  grid-template-columns: auto 1fr;
  color: var(--accent-primary-default);
  min-height: 100%;

  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    display: none;
  }
`

const Burger = styled.div`
  display: flex;
  min-height: 100%;
  margin: 0 var(--spacing-16px);
  align-items: center;
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  min-height: 100%;
`

const linkCss = css`
  display: flex;
  align-items: center;
`

const SlideMenu = styled.div`
  position: absolute;
  min-height: calc(100vh - 48px);
  min-height: calc(100dvh - 48px);
  width: 100%;
  top: 48px;
  z-index: 2;
  transition: opacity 0.1s ease-in-out;
  opacity: 0;
  background-color: ${Colors.mailruMenu};
  overflow-y: auto;
  pointer-events: none;
`

const showMenuCss = css`
  pointer-events: auto;
  opacity: 1;
`

const ExternalLink = styled.a`
  display: block;
  position: relative;
  padding: 10px 15px 10px 10px;
  background: ${Colors.mailruMenu};
  color: ${Colors.mailMenuText};
  font: normal 18px/22px 'Helvetica Neue', Arial, Tahoma, sans-serif;
  overflow: hidden;
  border-bottom: 1px solid ${Colors.mailruBorderColor};
  text-decoration: none;
`
